import { Component } from '@angular/core';
import { PillButtonComponent } from '../../shared/ui/pill-button/pill-button.component';

@Component({
  selector: 'app-hero',
  standalone: true,
  imports: [PillButtonComponent],
  templateUrl: './hero.component.html',
  styleUrl: './hero.component.scss',
})
export class HeroComponent {
  readonly companyLogoUrl = '/assets/logo_completa.png';
}
